import {parse} from 'query-string';

/**
 * Checks to see if there is a backend override in the URL query string
 *
 * @return  {Object}  An object with the header name and value or an empty object
 */

const getOverrideParams = experiment => {
  const overrideParams = parse(window?.location?.search || '');
  const overrideKey = `flipper_override_${experiment}`;
  const params = overrideParams[overrideKey] || null;

  return params || null;
};

export default getOverrideParams;
